// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.volume-indicator_volumeLabel__H2\\+fq {
  width: 125px;
  height: 60px;

  font-size: 12px;
  line-height: 60px;
  text-align: center;

  background-color: var(--labelOverlayColor);
}

.volume-indicator_volumeWrapper__SLDRV svg {
  display: block;
  margin: auto;
  margin-bottom: 14px;
  fill: var(--overlayForeground);
}
`, "",{"version":3,"sources":["webpack://./src/components/overlay/volume-indicator.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;;EAEZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;;EAElB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;AAChC","sourcesContent":[".volumeLabel {\n  width: 125px;\n  height: 60px;\n\n  font-size: 12px;\n  line-height: 60px;\n  text-align: center;\n\n  background-color: var(--labelOverlayColor);\n}\n\n.volumeWrapper svg {\n  display: block;\n  margin: auto;\n  margin-bottom: 14px;\n  fill: var(--overlayForeground);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"volumeLabel": `volume-indicator_volumeLabel__H2+fq`,
	"volumeWrapper": `volume-indicator_volumeWrapper__SLDRV`
};
module.exports = ___CSS_LOADER_EXPORT___;
